<div class="header">
  <app-nav-button *ngIf="themeService.isClosable()" icon="close" (clickEvent)="onCloseClicked()" />
  <div class="header-image-container">
    <app-game-icon 
    *ngIf="themeService.headerHasGameIcon()"
    [game]="gameId"
    size="--spacing-2x-large"
    class="game-icon"></app-game-icon>
    <app-game-title [wordmarkUrl]="themeService.wordmarkUrl(gameId)" [title]="gameName" [isWordmark]="themeService.headerHasWordmark()"></app-game-title>
  </div>
  <div
    *ngIf="themeService.showBalance()"
    class="balance-pill"
    [ngStyle]="balancePillStyles | theme">
    <span> {{ balance }} </span>
    <ion-spinner *ngIf="!balance" name="crescent"/>
    <app-currency-icon 
      *ngIf="currencyIcon"
      [icon]="currencyIcon" 
      sizeCss="--icon-medium"
      class="currency-icon" />
  </div>
  <app-nav-button *ngIf="OperatorService.IsDemo" icon="brush" (clickEvent)="onThemeClicked()" />
</div>
<app-tab-bar *ngIf="tabs" [tabs]="tabs" buttonType="tab" (tabSelected)="onTabSelected($event)" />
